export const assetSlugToUrl = {
  rial: "/wallet-rial-pos",
  crypto: "/wallet-tether",
  gold: "/wallet-gold-melted",
  currency: "/wallet-curency",
  investment: "/wallet-investment",
};

export const urlToAssetSlug = Object.fromEntries(
  Object.entries(assetSlugToUrl).map(([slug, url]) => [url, slug])
);

export const getAssetTypeUrl = (slug, type) => {
  const base = assetSlugToUrl[slug] ?? "/";
  return `${base}?type=${type}`;
};

export const getAssetTypeTitle = (assetTypes, { type, pathname }) => {
  if (!assetTypes?.length) return null;

  if (type) {
    const matchedByType = assetTypes.find(
      (item) => item.type === Number(type)
    );
    if (matchedByType) return matchedByType.title;
  }

  const slug = urlToAssetSlug[pathname];
  if (slug) {
    const matchedBySlug = assetTypes.find((item) => item.slug === slug);
    if (matchedBySlug) return matchedBySlug.title;
  }

  return null;
};
